import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PermissionStates } from '../../permission-controller/root';
import { TeamPermStates } from '../states';
import { teamPermAdapters, TeamPermState } from '../states/team-permissions.states';

export const teamPermFeatureKey = 'teamPerm';

export const selectTeamPermFeature = createFeatureSelector<TeamPermState>(teamPermFeatureKey);

export const selectCurrentUser = (state: PermissionStates) => state.permissions.teamPerm.currentUser;
export const selectTeam = (state: PermissionStates) => state.permissions.teamPerm.selectedTeam;
export const selectTeamRole = (state: PermissionStates) => state.permissions.teamPerm.selectedTeamRole;
export const selectDetailsForm = (state: PermissionStates) => state.permissions.teamPerm.detailsForm;
export const selectUpdateTeamListing = (state: PermissionStates) => state.permissions.teamPerm.updateTeamListing;
export const selectMember = (state: PermissionStates) => state.permissions.teamPerm.selectedMember;
export const selectUpdateMemberListing = (state: PermissionStates) => state.permissions.teamPerm.updateMemberListing;
export const selectUpdateAddMemberListing = (state: PermissionStates) => state.permissions.teamPerm.updateAddMemberListing;
export const selectUpdateRoleListing = (state: PermissionStates) => state.permissions.teamPerm.updateRoleListing;

export const selectGuid = (state: PermissionStates) => state.permissions.teamPerm.selectedGuid;
export const selectRequiresUpdate = (state: PermissionStates) => state.permissions.teamPerm.requiresUpdate;

export const {
    selectIds,
    selectEntities,
    selectAll,
    selectTotal
} = teamPermAdapters.getSelectors(selectTeamPermFeature);
